import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { removeFromTemplate, RemoveFromTemplateAction } from 'store/data/templates';
import { ActionPayload } from 'store/types';

export function useRemoveFromTemplate(): LocalOperation<
	(payload: ActionPayload<RemoveFromTemplateAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<RemoveFromTemplateAction>) {
		dispatch(removeFromTemplate(payload));
	}

	return handler;
}
